import { useState, useEffect } from "react";
import { Modal, Button, ProgressBar } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router-dom";
import Swal from "sweetalert2";
import { addSingelCandidate } from "../Actions/CandidateAction";
import Step1 from "./step-1";
import Step2 from "./step-2";
import Step3 from "./step-3";
import submitModel from "./submitModel";

const StepMap = {
  1: { label: "Personal Details", type: "personal_details" },
  2: { label: "Educational Details", type: "educational_details" },
  3: { label: "Skills and Projects", type: "skills_and_projects" },
};

function getForm(step, getFormValidity, getData, data, setShowModal) {
  if (step === 1)
    return (
      <Step1
        data={data[1]}
        getFormValidity={getFormValidity}
        getData={getData}
      />
    );
  else if (step === 2)
    return (
      <Step2
        data={data[2]}
        getFormValidity={getFormValidity}
        getData={getData}
      />
    );
  else if (step === 3)
    return (
      <Step3
        data={data[3]}
        getFormValidity={getFormValidity}
        getData={getData}
        setShowModal={setShowModal}
      />
    );
}

function ProfileForms(props) {
  const MIN_STEP = 1;
  const MAX_STEP = 3;
  const [step, setStep] = useState(1);
  const [progress, setProgress] = useState(0);
  const [isFormValid, setIfFormValid] = useState(true);
  const [data, setData] = useState({ 1: {}, 2: {}, 3: {} });
  const [showModal, setShowModal] = useState(props.show);
  const history = useHistory();

  useEffect(() => {
    setProgress(step * 33.33);
  }, [step]);

  const onSubmit = () => {
    setData({ ...data });
    const jsonToPost = submitModel(data);
    addSingelCandidate(jsonToPost).then((res) => {
      if (res.error) {
        Swal.fire("Error", res.message, "error");
      } else {
        localStorage.setItem("user_status", res.user_status);
        Swal.fire(res.message);
        history.push("/profile");
      }
    });
  };

  const onNextClick = () => {
    setData({ ...data });
    if (isFormValid) setStep(step + 1);
  };

  const onBackClick = () => {
    setStep(step - 1);
  };

  const getFormValidity = (status) => {
    setIfFormValid(status);
  };

  const getData = (step, values) => {
    data[step] = values;
  };

  return (
    <Modal
      show={showModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop={props.handleClose ? "true" : "static"}
      dialogClassName="profile-forms-modal"
      contentClassName="profile-forms-modal-content"
      onHide={props.handleClose}
    >
      <Modal.Header className="p-1 pl-2 d-flex flex-column">
        <Modal.Title id="contained-modal-title-vcenter w-100">
          {StepMap[step].label}
        </Modal.Title>
        <div className="w-100">
          <ProgressBar now={progress} style={{ height: "5px" }} />
        </div>
      </Modal.Header>
      <Modal.Body className="bg-light overflow-auto">
        {getForm(step, getFormValidity, getData, data, setShowModal)}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onBackClick} disabled={step <= MIN_STEP}>
          Back
        </Button>
        {step === MAX_STEP ? (
          <Button onClick={onSubmit} disabled={!isFormValid}>
            Submit
          </Button>
        ) : (
          <Button onClick={onNextClick} disabled={!isFormValid}>
            Next
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default ProfileForms;
